"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Img = exports.ContentWrapper = exports.Wrapper = exports.BACKGROUND_COLOR = void 0;
// import { parseToRgb, toColorString } from 'polished';
var polished_1 = require("polished");
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var VerticalSpacer_1 = __importDefault(require("../../utils/VerticalSpacer"));
var Images_1 = require("../Images");
exports.BACKGROUND_COLOR = {
    blue: 'WARM_BLUE_40',
    red: 'RED_20',
    yellow: 'YELLOW_40',
    green: 'GREEN_20',
    pink: 'PINK_20',
    grey: 'GREY_10',
    white: 'WHITE',
};
var getLinearGradient = function (color) {
    var rgb = polished_1.parseToRgb(color);
    return "linear-gradient(\n    to right,\n    " + color + ",\n    rgba(" + rgb.red + ", " + rgb.green + ", " + rgb.blue + ", 0) 75%,\n    rgba(" + rgb.red + ", " + rgb.green + ", " + rgb.blue + ", 0)\n  )";
};
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  border-radius: 10px;\n  overflow: hidden;\n  padding: 24px;\n  background-color: ", ";\n  justify-content: space-between;\n  align-items: center;\n  border: ", ";\n\n  &:before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    content: '';\n    background-image: ", ";\n    z-index: 1;\n  }\n\n  @media ", " {\n    flex-wrap: nowrap;\n    padding: 40px 48px;\n  }\n\n  @media ", " {\n    padding: 48px 56px;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  border-radius: 10px;\n  overflow: hidden;\n  padding: 24px;\n  background-color: ", ";\n  justify-content: space-between;\n  align-items: center;\n  border: ", ";\n\n  &:before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    content: '';\n    background-image: ",
    ";\n    z-index: 1;\n  }\n\n  @media ", " {\n    flex-wrap: nowrap;\n    padding: 40px 48px;\n  }\n\n  @media ", " {\n    padding: 48px 56px;\n  }\n"])), function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return theme_1.theme.colors[exports.BACKGROUND_COLOR[$backgroundColor]];
}, function (_a) {
    var $border = _a.$border;
    return $border && "1px solid " + theme_1.theme.colors[$border];
}, function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return getLinearGradient(theme_1.theme.colors[exports.BACKGROUND_COLOR[$backgroundColor]]);
}, theme_1.theme.breakpoints.medium, theme_1.theme.breakpoints.large);
exports.ContentWrapper = styled_components_1.default(VerticalSpacer_1.default).attrs({
    amount: {
        small: 16,
        medium: 16,
        large: 24,
    },
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  z-index: 2;\n"], ["\n  position: relative;\n  z-index: 2;\n"])));
exports.Img = styled_components_1.default(Images_1.Img)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  @media ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  @media ", " {\n    display: block;\n  }\n"])), theme_1.theme.breakpoints.medium);
var templateObject_1, templateObject_2, templateObject_3;
